module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBd.svg?v=34fe2ae3ceed00dcef0bfea4f7cf92e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBd.svg
// module id = 638
// module chunks = 0